const pricingDetails = {
  // HeroSection
  'pricingDetails.hero.homeLink': 'Home',
  'pricingDetails.hero.pricingLink': 'Tuition & Benefits',
  'pricingDetails.hero.currentPage': 'Detailed Tuition Breakdown',
  'pricingDetails.hero.imgAlt': 'A refined still life of butler tools and accessories',

  // breadcrumb (page.tsx)
  'pricingDetails.breadcrumb.home': 'Home',
  'pricingDetails.breadcrumb.pricing': 'Tuition & Benefits',
  'pricingDetails.breadcrumb.current': 'Detailed Tuition Breakdown',

  // CourseDetailCards
  'pricingDetails.cards.label': 'TUITION BREAKDOWN',
  'pricingDetails.cards.title': 'What Each Course Includes',
  'pricingDetails.cards.titleEn': 'What Each Course Includes',
  'pricingDetails.cards.lead': 'We provide a full, transparent breakdown of what your tuition covers — from class hours and textbooks to practicum, enrollment gifts, and the final examination fee. All fees are quoted inclusive of tax.',
  'pricingDetails.cards.taxIncluded': '(tax incl.)',
  'pricingDetails.cards.afterExam': 'Upon passing the final practical examination:',
  'pricingDetails.cards.courseLink': 'View full course details',
  'pricingDetails.cards.img0Alt': 'A student in an apron practising table setting',
  'pricingDetails.cards.img1Alt': 'A student practising wine service during a practicum session',
  'pricingDetails.cards.img2Alt': 'A Master Course student being measured for a custom-made vest',
  'pricingDetails.cards.img0Caption': 'Table-setting practicum session',
  'pricingDetails.cards.img1Caption': 'Special practicum: wine service experience',
  'pricingDetails.cards.img2Caption': 'Custom-made vest fitting session',

  // TransferDiscount (details page)
  'pricingDetails.transfer.label': 'TRANSFER BENEFIT',
  'pricingDetails.transfer.title': 'Lateral Enrollment Discount',
  'pricingDetails.transfer.titleEn': 'How Transfer Discounts Apply',
  'pricingDetails.transfer.lead': 'The more courses you complete in sequence, the more you save overall. Discounts are applied upon declaration of your previous course completion at the time of application.',
  'pricingDetails.transfer.discount': 'JPY reduction (tax incl.)',
  'pricingDetails.transfer.note': 'When applying for a lateral enrollment discount, please provide your previous course completion certificate number at the time of application.',
  'pricingDetails.transfer.consultLink': 'Contact us via a free individual consultation for any enquiries.',

  // PaymentFlow
  'pricingDetails.flow.label': 'PAYMENT FLOW',
  'pricingDetails.flow.title': 'How Payment Works',
  'pricingDetails.flow.titleEn': 'How Enrollment Works',
  'pricingDetails.flow.lead': 'After submitting your application, we will send you full enrollment instructions including bank account details. Enrollment is confirmed once payment is received.',
  'pricingDetails.flow.importantTitle': 'Important Payment Notes',
  'pricingDetails.flow.note1': 'Bank transfer (single lump-sum payment only) — instalment plans and credit card payments are not accepted.',
  'pricingDetails.flow.note2': 'Payment is due 14 days before the course start date.',
  'pricingDetails.flow.note3': 'Bank transfer fees are the responsibility of the applicant.',
  'pricingDetails.flow.note4': 'If payment is not received by the deadline, your application may be cancelled.',

  // CTASection
  'pricingDetails.cta.label': 'NEXT STEP',
  'pricingDetails.cta.title': 'Have Questions? We Are Here to Help',
  'pricingDetails.cta.lead': 'Our team is happy to answer any questions about fees or payment during a complimentary individual consultation. You are also welcome to start with a free brochure.',
  'pricingDetails.cta.onlineNote': '* Online consultations are also available.',
  'pricingDetails.cta.backBtn': 'Back to Tuition Overview',
  'pricingDetails.cta.brochureBtn': 'Request a Brochure (Free)',
  'pricingDetails.cta.consultBtn': 'Book a Consultation',

  // FAQSection
  'pricingDetails.faq.label': 'FAQ',
  'pricingDetails.faq.title': 'Frequently Asked Questions',
  'pricingDetails.faq.titleEn': 'Frequently Asked Questions',
  'pricingDetails.faq.contactNote': 'For further enquiries, please use our',
  'pricingDetails.faq.contactLink': 'contact form',
  'pricingDetails.faq.contactSuffix': '.',

  // RelatedPages
  'pricingDetails.related.label': 'LEARN MORE',
  'pricingDetails.related.title': 'Related Pages',
  'pricingDetails.related.titleEn': 'Explore Further',
  'pricingDetails.related.arrowLabel': 'Learn more',

  // footer
  'pricingDetails.footer.lastUpdated': 'Last updated: 13 June 2026',
  'pricingDetails.backToTop.ariaLabel': 'Back to top',

  // detailsHero
  'pricingDetails.hero.title': 'Detailed Tuition Breakdown',
  'pricingDetails.hero.lead': 'Here you will find a full line-item breakdown of what each course fee covers.',

  // courseDetails rows
  'pricingDetails.course.0.name': 'Essential Course',
  'pricingDetails.course.0.duration': '1 Month',
  'pricingDetails.course.0.days': '8 Days',
  'pricingDetails.course.0.hours': '48 Hours',
  'pricingDetails.course.0.lead': 'An introductory course that systematically builds the foundational skills and knowledge required of a butler — at a manageable pace.',
  'pricingDetails.course.0.qualification': 'Certified Associate Butler',
  'pricingDetails.course.0.cat.0.label': 'Classes',
  'pricingDetails.course.0.cat.0.items.0': 'Face-to-face instruction, 48 hours (8 days, Saturday & Sunday)',
  'pricingDetails.course.0.cat.0.items.1': 'Curriculum combining lectures and practical sessions',
  'pricingDetails.course.0.cat.0.items.2': 'Small class sizes (capped intake per cohort)',
  'pricingDetails.course.0.cat.1.label': 'Textbooks',
  'pricingDetails.course.0.cat.1.items.0': 'Association-supervised textbook set: 5 volumes (E1–E5)',
  'pricingDetails.course.0.cat.1.items.1': 'Practicum handout pack',
  'pricingDetails.course.0.cat.2.label': 'Practicum',
  'pricingDetails.course.0.cat.2.items.0': 'Role-play practicum sessions in the academy studio',
  'pricingDetails.course.0.cat.2.items.1': 'Table-setting, tea service, and clothing-care practicals',
  'pricingDetails.course.0.cat.3.label': 'Gifts',
  'pricingDetails.course.0.cat.3.items.0': 'Original practicum apron',
  'pricingDetails.course.0.cat.3.items.1': 'White gloves (high quality, provided as standard)',
  'pricingDetails.course.0.cat.4.label': 'Examination',
  'pricingDetails.course.0.cat.4.items.0': 'Final practical examination',
  'pricingDetails.course.0.cat.4.items.1': 'Successful candidates receive the Certified Associate Butler credential and lapel pin',

  'pricingDetails.course.1.name': 'Advanced Course',
  'pricingDetails.course.1.duration': '2 Months',
  'pricingDetails.course.1.days': '12 Days',
  'pricingDetails.course.1.hours': '72 Hours',
  'pricingDetails.course.1.lead': 'An intermediate course that builds on the foundation to develop advanced service techniques and hospitality management capabilities.',
  'pricingDetails.course.1.qualification': 'Certified Professional Butler',
  'pricingDetails.course.1.cat.0.label': 'Classes',
  'pricingDetails.course.1.cat.0.items.0': 'Face-to-face instruction, 72 hours (12 days, Saturday & Sunday)',
  'pricingDetails.course.1.cat.0.items.1': 'Curriculum combining lectures and practical sessions',
  'pricingDetails.course.1.cat.0.items.2': 'Small class sizes (capped intake per cohort)',
  'pricingDetails.course.1.cat.1.label': 'Textbooks',
  'pricingDetails.course.1.cat.1.items.0': 'Association-supervised textbook set: 10 volumes total (E1–E5 + A1–A5)',
  'pricingDetails.course.1.cat.1.items.1': 'In addition to the 5 foundational (E) volumes, includes 5 applied (A) volumes covering household finance, secretarial support, table service, event planning, and lifestyle management',
  'pricingDetails.course.1.cat.1.items.2': 'Practicum handout pack',
  'pricingDetails.course.1.cat.2.label': 'Practicum',
  'pricingDetails.course.1.cat.2.items.0': 'Role-play practicum sessions in the academy studio',
  'pricingDetails.course.1.cat.2.items.1': 'Special experiential practicum (1 session) — experiencing real-world service as a guest',
  'pricingDetails.course.1.cat.2.items.2': 'Wine and tea service techniques',
  'pricingDetails.course.1.cat.2.items.3': 'Event set-up and coordination exercise',
  'pricingDetails.course.1.cat.3.label': 'Gifts',
  'pricingDetails.course.1.cat.3.items.0': 'Wine opener set',
  'pricingDetails.course.1.cat.3.items.1': 'White gloves (high quality, provided as standard)',
  'pricingDetails.course.1.cat.3.items.2': 'Graduate job information (in preparation)',
  'pricingDetails.course.1.cat.4.label': 'Examination',
  'pricingDetails.course.1.cat.4.items.0': 'Final practical examination',
  'pricingDetails.course.1.cat.4.items.1': 'Successful candidates receive the Certified Professional Butler credential and lapel pin',

  'pricingDetails.course.2.name': 'Master Course',
  'pricingDetails.course.2.duration': '3 Months',
  'pricingDetails.course.2.days': '16 Days',
  'pricingDetails.course.2.hours': '96 Hours',
  'pricingDetails.course.2.lead': 'The highest-level course, developing comprehensive professional expertise and management capability across all areas required of a professional butler.',
  'pricingDetails.course.2.qualification': 'Certified Master Butler',
  'pricingDetails.course.2.cat.0.label': 'Classes',
  'pricingDetails.course.2.cat.0.items.0': 'Face-to-face instruction, 96 hours (16 days, Saturday & Sunday)',
  'pricingDetails.course.2.cat.0.items.1': 'Curriculum combining lectures and practical sessions',
  'pricingDetails.course.2.cat.0.items.2': 'Small class sizes (capped intake per cohort)',
  'pricingDetails.course.2.cat.1.label': 'Textbooks',
  'pricingDetails.course.2.cat.1.items.0': 'Association-supervised textbook set: all 15 volumes (E1–E5, A1–A5, M1–M5)',
  'pricingDetails.course.2.cat.1.items.1': 'In addition to the E and A series, includes 5 master-level (M) volumes covering international protocol, crisis management, and VVIP service',
  'pricingDetails.course.2.cat.1.items.2': 'Practicum handout pack',
  'pricingDetails.course.2.cat.2.label': 'Practicum',
  'pricingDetails.course.2.cat.2.items.0': 'Role-play practicum sessions in the academy studio',
  'pricingDetails.course.2.cat.2.items.1': 'Special experiential practicum (1 session)',
  'pricingDetails.course.2.cat.2.items.2': 'Master classes (2 sessions, with guest instructors)',
  'pricingDetails.course.2.cat.2.items.3': 'Individual coaching (2 sessions, one-to-one with lead instructor)',
  'pricingDetails.course.2.cat.2.items.4': 'Comprehensive practical examination (integrating all skills from the programme)',
  'pricingDetails.course.2.cat.3.label': 'Gifts',
  'pricingDetails.course.2.cat.3.items.0': 'Custom-made vest (individually fitted and tailored)',
  'pricingDetails.course.2.cat.3.items.1': 'Luxury pocket watch',
  'pricingDetails.course.2.cat.3.items.2': 'White gloves (high quality, provided as standard)',
  'pricingDetails.course.2.cat.3.items.3': 'Graduate job information (in preparation)',
  'pricingDetails.course.2.cat.4.label': 'Examination',
  'pricingDetails.course.2.cat.4.items.0': 'Final practical examination',
  'pricingDetails.course.2.cat.4.items.1': 'Successful candidates receive the Certified Master Butler credential and lapel pin',

  // transferDiscountDetails
  'pricingDetails.transferDetail.0.from': 'Essential Course graduate',
  'pricingDetails.transferDetail.0.to': 'Advancing to Advanced Course',
  'pricingDetails.transferDetail.1.from': 'Advanced Course graduate',
  'pricingDetails.transferDetail.1.to': 'Advancing to Master Course',

  // paymentFlow
  'pricingDetails.flow.0.title': 'Application',
  'pricingDetails.flow.0.desc': 'Submit your application via the online form, selecting your desired course. Places are allocated on a first-come, first-served basis.',
  'pricingDetails.flow.1.title': 'Enrollment Agreement',
  'pricingDetails.flow.1.desc': 'After reviewing your application, we will send you the enrollment agreement and full instructions.',
  'pricingDetails.flow.2.title': 'Bank Transfer',
  'pricingDetails.flow.2.desc': 'Please transfer the course fee in full by bank transfer no later than 14 days before the start date. Instalment plans and credit card payments are not accepted.',
  'pricingDetails.flow.3.title': 'Enrollment Confirmed',
  'pricingDetails.flow.3.desc': 'Once payment has been received, your enrollment is confirmed. We will send you full pre-course details, including the start date and what to bring.',

  // detailsFaqs
  'pricingDetails.faq.0.q': 'Is the special experiential practicum included in the fee?',
  'pricingDetails.faq.0.a': 'Details of the costs covered will be provided at the time of application (travel to the venue is not included).',
  'pricingDetails.faq.1.q': 'How is the lateral enrollment discount applied?',
  'pricingDetails.faq.1.a': 'Essential Course graduates advancing to Advanced receive a JPY 80,000 reduction; Advanced Course graduates advancing to Master receive a JPY 180,000 reduction. Please declare this at the time of application.',
  'pricingDetails.faq.2.q': 'Are there any additional costs?',
  'pricingDetails.faq.2.a': 'Textbooks, practicum, enrollment gifts, and the examination fee are all included in the course fee. Apart from travel to off-site practicums, no additional charges apply as a general rule.',

  // detailsRelatedPages
  'pricingDetails.related.0.title': 'Tuition Overview',
  'pricingDetails.related.0.desc': 'Course fees and what is included',
  'pricingDetails.related.1.title': 'Enrollment Benefits',
  'pricingDetails.related.1.desc': 'Practical enrollment gifts',
  'pricingDetails.related.2.title': 'Completion Certificate & Certification',
  'pricingDetails.related.2.desc': 'Association certification earned upon completion',
  'pricingDetails.related.3.title': 'Courses Overview',
  'pricingDetails.related.3.desc': 'Compare all three courses at a glance',
};

export default pricingDetails;
